import jQuery from 'jquery';
import Swiper from "swiper";
import Used from './classes/Used';
import noUiSlider from 'nouislider';



window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;


// Apenas para o carregamento do arquivo:
import '../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
// Only works with require function
require('../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');


const fixedHeaderMobile = $('.header-fixed-mobile')
const fixedFooterMobile = $('.footer-fixed-mobile')
const mainForm = $('.form-main')
const backdropNavbar = $('.backdrop-navbar')
const fixedMenu = $('.fixed-menu')
const btnFormFixed = $('.btn-form-fixed')
const fixedForm = $('.modal-form')
const btnModalFilter = $('.btn-modal-filter')
const modalFilter = $('.modal-filter')
const btnModalFavorites = $('.btn-modal-favorites')
// Menu
const btnMenu = $('.btn-menu')
const menuIcons = $('.menu-list.hidden')
const sideMenu = $('.side-menu')
const fixedFormMenu = $('.form-cotacao')
const btnCotacao = $('.btn-cotacao')
const headerThreshold = window.innerHeight * .3
const btnMenuMobile = $('.btn-menu-mobile')
const sideMenuMobile = $('.menu-dropdown-mobile')
const btnOpenForms = $('.btn-open-form')

// Import utils functions
import tabs from './functions/tabs'
import carousels from './functions/sliders'
import accordions from './functions/accordions'
import switchColors from './functions/colors'

getModelFromParams();

$(document).ready(function () {

  // Initialize Tabs
  tabs.tabsInit();

  // Used class
  const filters = JSON.parse(document.querySelector('#used-filter-data').getAttribute('data-filter'));
  new Used(filters);

  //Hide Favorite Bar
  // toggleFavoriteBar();
})

function swapSelect(id, value) {

  var html = document.getElementById(id).innerHTML;
  $('.swap-select').html(html);
  $('.swap-select').find('#carroNovo').val(value);
}

function getModelFromParams() {

  let searchParams = new URLSearchParams(window.location.search);

  const modelname = searchParams.get('modelname');

  if (modelname) {
    $('.select-model-test').val(modelname);
    const myInput = $('select#model');
    const imgWrapper = $('form .test-drive-form-img img');

    const img = $('.select-model-test').find('option:selected').attr('data-image');
    imgWrapper.attr('src', img);

  }

}

// Tabs here
tabs.tabsCreate();

// Swipers Sliders here
carousels.swipersInit();

// Accordions here
accordions.accordionsCreate();

// Switch Colors here
switchColors.switchColors();

changeTestDriveImage();

function changeTestDriveImage() {
  const myInput = $('select#model')
  const imgWrapper = $('form .test-drive-form-img img')

  myInput.on('change', function (e) {
    const img = $(e.target).find('option:selected').attr('data-image')
    imgWrapper.attr('src', img)
  })

}


$(window).on('scroll', function () {
  if (isMobile()) {
    toggleElOnScroll(fixedHeaderMobile)
    toggleElOnScroll(fixedFooterMobile)
  } else {
    toggleDisplayOnScroll(btnMenu, headerThreshold)
    toggleElOnScroll(menuIcons, headerThreshold)
    toggleFormOnScroll(fixedFormMenu, headerThreshold)
    // toggleElOnScroll(fixedHeader, headerThreshold)
    // toggleElOnScroll(mainForm, headerThreshold, true)
  }
})



function toggleDisplayOnScroll(el, threshold = 50, reverse = false) {

  function changeDisplay(el, show,) {
    $(el).css('display', show ? 'flex' : 'none')
  }

  if ($(window).scrollTop() > threshold) {
    reverse ? changeDisplay(el, 0) : changeDisplay(el, 1)
  } else {
    reverse ? changeDisplay(el, 1) : changeDisplay(el, 0)
  }
}

function toggleElOnScroll(el, threshold = 50, reverse = false) {
  if ($(window).scrollTop() > threshold) {
    reverse ? el.fadeOut() : el.fadeIn()
  } else {
    reverse ? el.fadeIn() : el.fadeOut()
  }
}

function toggleFormOnScroll(el, threshold = 50, reverse = false) {

  if ($(window).scrollTop() > threshold) {

    // to open
    if (btnCotacao.hasClass('active')) {
      btnCotacao.removeClass('active')
      fixedFormMenu.fadeOut('fast')
      // console.log('fechar form')
    }
    else {
      // console.log('form fechado')
    }

  } else {
    // to close
    if (!btnCotacao.hasClass('active')) {
      btnCotacao.addClass('active')
      fixedFormMenu.fadeIn('fast')
      // console.log('Abrir form')
    } else {
      // console.log('form fechado')
    }
  }

}

function isMobile() {
  if ($(window).width() > 992) {
    return false
  }
  return true
}


// Modals
function popUp(selector) {
  $('body,html').addClass('scroll-lock')
  selector.fadeIn('fast')
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut()
  $('body,html').removeClass('scroll-lock')
}
function modalInject(data, target) {
  console.log('Rick')
  const { title, img, text } = data
  console.log(title, img, text)
  $(target).find('.promo-title').html(title)
  $(target).find('.promotion-img').attr('src', img)
  $(target).find('.promotion-text').html(text)

  popUp($(target))

}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target')
  const data = $(this).data('json')
  data ? modalInject(data, el) : popUp($(el))
})

$('.modal-overlay, .btn-close-modal').on('click', function (e) {
  $(e.target).hasClass('form-close') ? popClose(true) : popClose()
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
})

$('.pop-up-content .btn-privacy').on('click', function () {
  const el = $(this).data('target')
  $(el).modal('show')
})

$('.btn-privacy').on('click', function (e) {
  e.preventDefault()
})




btnOpenForms.on('click', function () {
  const el = $(this).data('target')
  popUp($(el))
})



$('.btn-scroll-top').on('click', function () {
  $('html,body').animate({ scrollTop: 0 }, '300')
});



btnFormFixed.on('click', function () {
  if (!fixedHeader.is(':visible') && !isMobile()) {

    $('html, body').animate({
      scrollTop: headerThreshold + 1
    }, 100);
  }
  controlModals(btnFormFixed, fixedForm)
})
fixedForm.on('click', function () {
  btnFormFixed.removeClass('active')
})

btnModalFilter.on('click', function () {
  controlModals(btnModalFilter, modalFilter)
})
modalFilter.on('click', function () {
  btnModalFilter.removeClass('active')
})

function navbarController(el) {
  $(el).toggleClass('active')
  if (!$(el).hasClass('active')) {
    // Close
    $(backdropNavbar).fadeOut('fast')
    $(sideMenu).fadeOut('fast')
    // menuIcons.fadeOut('fast')
    $('body,html').removeClass('scroll-lock')
  } else {
    // Open
    $(backdropNavbar).fadeIn('fast')
    $(sideMenu).fadeIn('fast')
    // menuIcons.fadeIn('fast')
    $('body,html').addClass('scroll-lock')
  }
}

btnMenu.on('click', function () {
  // controlModals($(this), fixedMenu)
  // $('.fixed-menu .pop-up-content').toggleClass('active')
  const formBtn = $('.btn-cotacao');
  navbarController(btnMenu)
  formBtn.hasClass('active') ? $(formBtn).trigger('click') : false
})

btnMenuMobile.on('click', function () {
  const el = $(this)
  el.toggleClass('active');
  el.hasClass('active')
    ? $('html,body').addClass('scroll-lock') &&
    sideMenuMobile.fadeIn('fast')
    : $('html,body').removeClass('scroll-lock') &&
    sideMenuMobile.fadeOut('fast')
})


$('.btn-cotacao').on('click', function (e) {
  $(this).hasClass('active') ? $('.form-cotacao').fadeOut(250) : $('.form-cotacao').fadeIn(250)

  $(this).toggleClass('active')
})
backdropNavbar.on('click', function (e) {
  navbarController(btnMenu)
})

fixedMenu.on('click', function () {
  btnMenu.removeClass('active')
  $('.fixed-menu .pop-up-content').removeClass('active')
})

//controls special modals interactions
function controlModals(btn, el) {
  if (btn.hasClass('active')) {
    popClose()
  } else {
    popClose()
    btnMenu.removeClass('active')
    btnModalFilter.removeClass('active')
    btnFormFixed.removeClass('active')
    $('.fixed-menu .pop-up-content').removeClass('active')
    popUp(el)
  }
  btn.toggleClass('active')
}

$('.btn-drop-menu').on('click', function () {
  const btn = $(this)
  btn.toggleClass(`active`)
  btn.find('.submenu').slideToggle('fast')
})

$('.btn-car-dropdown').on('click', function (e) {
  e.preventDefault()
  const btn = $(this)
  const parentContainer = btn.data('rel')
  btn.toggleClass('active')
  $(`.${parentContainer} > .cars-dropdown`).slideToggle('fast')
})




//Select box limit and order
$('#limitSelect').change(function () {
  $('#limitCars').val($('#limitSelect').val());
  $('#filterSearch').submit();
});

$('#orderSelect').change(function () {
  $('#orderCars').val($('#orderSelect').val());
  $('#filterSearch').submit();

});

// update upload field text
$(".custom-file-input").on("change", function () {
  const fileName = $(this).val().split("\\").pop()
  $(this).siblings(".custom-file-label").addClass("selected").html(fileName)
});



/* ----- JS Vannila ----- */

const headerScrolled = document.querySelector('.header.fixed');
const headerMenuDropdown = document.querySelector('.header-menu-dropdown');

const btnCallForm = document.querySelectorAll('.button-call-form');
var selectModelsWrapper = document.querySelectorAll("select[name=produto]");

const formMain = document.querySelector('.form-main');
const formMainMobile = document.querySelector('.form-main-mobile');
const filterMainMobile = document.querySelector('.filter-main-mobile');
const closeFormMobile = document.querySelectorAll('.btn-close-form');

const lockScreen = document.querySelector('.lock-screen');
const redirectHome = document.querySelector('.redirect-countdown');
const usedCarsURLParameter = window.location.pathname;

// Function Call
window.addEventListener('scroll', () => {
  showPartialsFixed('.header.fixed', 'show-header-scrolled', 'hide-header-scrolled');
  showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
  showPartialsFixed('.header-mobile.fixed', 'show-header-scrolled', 'hide-header-scrolled');
});

// Functions
const buttonCotationBehavior = (button) => {
  let buttonSelected = document.querySelectorAll(button);

  buttonSelected.forEach((btn) => {
    btn.addEventListener('click', () => {
      formControl();

      if (!headerMenuDropdown.classList.contains('d-flex')) {
        lockScreenScroll();
      }

      lockScreen.classList.toggle('d-flex');

      if (btn.classList.contains('button-product-cotation')) {
        const dataModel = btn.getAttribute("data-model");
        const dataId = btn.getAttribute("data-id");

        if (dataId)
          swapSelect(dataId, dataModel);


        selectModelsWrapper.forEach((select) => {

          select.value = dataModel;
        });

        if (screen.width >= 992) {
          if (!headerScrolled.classList.contains('show-header-scrolled')) {
            if (usedCarsURLParameter == '/novos') {
              window.scrollTo(0, 130);
            } else {
              window.scrollTo(0, 710);
            }

            showPartialsFixed('.header.fixed', 'show-header-scrolled', 'hide-header-scrolled');
          }
        }
      }
    });
  });
}

buttonCotationBehavior('.button-call-form');
buttonCotationBehavior('.button-product-cotation');

const closeMenu = `
<i class="icon-close"></i>
<span class="menu-sidebar-text">Fechar</span>`;

const openMenu = `
<i class="icon-menu"></i>
<span class="menu-sidebar-text">Menu</span>`;

const openSidebarBehavior = (menu) => {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((target) => {

    target.addEventListener('click', () => {

      headerMenuDropdown.classList.toggle('d-flex')

      target.innerHTML === closeMenu
        ? target.innerHTML = openMenu
        : target.innerHTML = closeMenu;

      if (!formMain.classList.contains('form-content-fixed')) {
        lockScreenScroll();
      }
    });
  });
}

openSidebarBehavior('.menu-sidebar');

const lockScreenScroll = () => {
  const elementsDOM = document.querySelector('body, html');
  elementsDOM.classList.toggle('scroll-lock');
}

const showPartialsFixed = (partial, partialShow, partialHide) => {
  const partialSelected = document.querySelectorAll(partial);

  partialSelected.forEach((partial) => {

    if (screen.width >= 992) {
      if (
        usedCarsURLParameter == '/novos' ||
        usedCarsURLParameter == '/test-drive' ||
        usedCarsURLParameter == '/trabalhe-conosco'
      ) {

        if (window.scrollY > 120) {
          partial.classList.add(partialShow);
          partial.classList.remove(partialHide);

        } else {
          if (partial.classList.contains(partialShow)) {
            partial.classList.add(partialHide);
            partial.classList.remove(partialShow);
          }
        }

      } else {

        if (window.scrollY > 700) {
          partial.classList.add(partialShow);
          partial.classList.remove(partialHide);
        } else {
          if (partial.classList.contains(partialShow)) {
            partial.classList.add(partialHide);
            partial.classList.remove(partialShow);
          }
        }
      }

    } else {

      if (window.scrollY > 150) {
        partial.classList.add(partialShow);
        partial.classList.remove(partialHide);

      } else {

        if (partial.classList.contains(partialShow)) {
          partial.classList.add(partialHide);
          partial.classList.remove(partialShow);
        }
      }
    }
  });
}

const formControl = () => {
  if (screen.width >= 992) {
    btnCallForm.forEach((btn) => {
      btn.innerHTML === "FECHAR"
        ? btn.innerHTML = "Solicitar cotação"
        : btn.innerHTML = "FECHAR";
    });

    formMain.classList.toggle('form-content-fixed');
  } else {

    if (usedCarsURLParameter == '/seminovos') {
      filterMainMobile.classList.add('d-flex');
    } else {
      formMainMobile.classList.add('d-flex');
    }
  }
}

closeFormMobile.forEach((btnClose) => {
  btnClose.addEventListener('click', () => {
    if (usedCarsURLParameter == '/seminovos') {
      filterMainMobile.classList.remove('d-flex');
    } else {
      formMainMobile.classList.remove('d-flex');
    }

    lockScreenScroll();
    lockScreen.classList.toggle('d-flex');
  });
});

// redirect timeout - thanks page
if (redirectHome != undefined) {
  let count = 5;

  setInterval(() => {
    if (count >= 0) {
      redirectHome.innerHTML = `${count}s`;
      count--;
    }
  }, 1000)

  setTimeout(() => {
    window.location.href = "/";
  }, 5500);
}

// insert current date on inputs type date
const date = new Date();

const day = String(date.getDate()).padStart(2, '0');
const month = String(date.getMonth() + 1).padStart(2, '0');
const year = date.getFullYear();
const currentDate = `${year}-${month}-${day}`;

const inputDate = document.querySelectorAll('input[type="date"]')

inputDate.forEach((input) => {
  input.value = currentDate;
  input.min = currentDate;
});
